import { css } from 'styled-components';
const unitlessProps = new Set([
    'flex',
    'opacity',
    'zIndex',
    'fontWeight',
    'lineHeight',
    'flexGrow',
    'flexShrink',
    'order',
    'zoom',
]);
export const hasStyleValues = (style) => Object.values(style).some((value) => value !== undefined && value !== null);
const styleToCss = (style) => {
    const importantStyle = {};
    Object.entries(style).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            if (typeof value === 'number') {
                const needsUnit = !unitlessProps.has(key);
                importantStyle[key] = `${value}${needsUnit ? 'px' : ''} !important`;
            }
            else {
                importantStyle[key] = `${value} !important`;
            }
        }
    });
    return css(importantStyle);
};
export default styleToCss;
